import React, { useEffect, useState } from "react";
import { useLoginFakeTeacherMutation } from "src/services";
import { useNavigate } from "react-router-dom";
import { Flex } from "@nubeteck/components";
import { Content } from "antd/es/layout/layout";
import { LargeHeadingStyled, SectionHeaderStyled } from "src/components/custom/texts/texts.styled";
import { Button, Form, Input, Skeleton } from "antd";
import { useErrorTeacherEmailRequiredToast } from "src/constants";
import { getEnterTeacherPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../StrapiError";

const FakeLoginTeachers = () => {
  const [form] = Form.useForm<any>();
  const { validateFields } = form;
  const [loginFake, { data, isSuccess, isLoading }] = useLoginFakeTeacherMutation();
  const navigate = useNavigate();
  const { locale } = useLocale();
  const [enterTeacherPage, setEnterTeacherPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError]= useState<boolean>(false);
  const showErrorTeacherEmailRequiredToast = useErrorTeacherEmailRequiredToast();

  useEffect(() => {
    if (isSuccess) {
      localStorage.setItem("token", data.data.token);
      localStorage.setItem("refreshToken", JSON.stringify(data.data.refreshToken));
      navigate("/");
      window.location.reload();
    }
  }, [data, isSuccess, navigate]);

  const submit = () => {
    validateFields(["correo"])
      .then((values) => {
        if (values) {
          loginFake(values);
        }
      })
      .catch(() => {
        showErrorTeacherEmailRequiredToast();
      });
  };

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setEnterTeacherPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    
    getEnterTeacherPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setEnterTeacherPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setEnterTeacherPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setEnterTeacherPage(null);
      }}
    />;
  }

  return (
    <Flex style={{ flexDirection: "column", width: "100%", alignSelf: "flex-start" }}>
      <Content style={{ marginTop: "16px" }}>
        <SectionHeaderStyled>
          <LargeHeadingStyled>{isLoadingContent ? <Skeleton.Input active size="large" style={{ width: 300 }} /> : (enterTeacherPage?.title || "Ingresar como usuario docente")}</LargeHeadingStyled>
        </SectionHeaderStyled>
        <Flex style={{ gap: "15px" }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={submit}
            style={{ display: "flex", flexDirection: "column", gap: 16 }}
            initialValues={{
              id: 1,
            }}
          >
            <Form.Item
              name="correo"
              label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (enterTeacherPage?.requered || "Correo del docente")}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: enterTeacherPage?.required_message || "Este campo es requerido",
                },
              ]}
            >
              <Input type="email" style={{ width: 300 }} />
            </Form.Item>

            <Button type="primary" size="large" htmlType="submit" loading={isLoading}>
              {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enterTeacherPage?.enter_button || "Ingresar")}
            </Button>
          </Form>
        </Flex>
      </Content>
    </Flex>
  );
};

export default FakeLoginTeachers;
